import * as React from 'react';

import { RichText } from 'prismic-reactjs';
import usePrismicComponentBody, {
  IPrismicComponentBody,
} from '../../hooks/usePrismicComponentBody';
import PrismicCode from './PrismicCode';
import htmlSerializer from './PrismicRender';

const prismicComponentList = (body: IPrismicComponentBody[]) => {
  const components = usePrismicComponentBody(body, 'component_list');

  if (components !== null && components[0] !== undefined && components[0].fields) {
    const componentArr = components[0].fields.map(({ component }) => {
      return component;
    });

    return componentArr.join('|');
  }

  return '';
};

const prismicComponentDemos = (body: IPrismicComponentBody[], type?: string) => {
  const demos = usePrismicComponentBody(body, 'component_demo');
  const useLang = type === 'web' ? 'language-html' : 'language-jsx';

  if (demos) {
    return (
      <div>
        {demos.map(({ primary, fields }) => {
          return (
            <>
              {primary?.demo_title && (
                <RichText render={primary?.demo_title} htmlSerializer={htmlSerializer} />
              )}
              {primary?.demo_description && (
                <RichText render={primary?.demo_description} htmlSerializer={htmlSerializer} />
              )}

              {fields?.map(({ demo_summary, demo_code }) => (
                <>
                  {demo_summary && (
                    <RichText render={demo_summary} htmlSerializer={htmlSerializer} />
                  )}
                  {demo_code &&
                    demo_code.map(({ text }) => (
                      <PrismicCode key={text} language={useLang}>
                        {text}
                      </PrismicCode>
                    ))}
                </>
              ))}
            </>
          );
        })}
      </div>
    );
  }

  return <></>;
};

export { prismicComponentList, prismicComponentDemos };
